const auth = {
  en: {
    auth: {
      // Shared sign-in labels and buttons live in messages.auth.*; only the
      // copy that is specific to the second factor belongs here.
      mfa: {
        // Lifetime copy is fixed at 5 minutes (API otp_ttl_seconds: 300). Do not
        // interpolate remaining minutes from codeExpiresIn.
        subtitle: 'We sent a {length}-digit code to {email}. It expires in 5 minutes.',
        subtitle_no_email: 'We sent a {length}-digit code to your email address. It expires in 5 minutes.',
        resend: 'Send a new code',
        resending: 'Sending...',
        resend_cooldown: 'You can request a new code in {seconds}s',
        resent: 'A new code is on its way.',
        expired: 'That code has expired. Request a new one to continue.',
        expires_in: 'Code expires in {time}',
        back: 'Use a different account'
      },
      errors: {
        required_fields: 'Enter your email and password.',
        unauthorized: 'Invalid email or password.',
        invalid_mfa_code: 'That code is not valid. Check your email and try again.',
        rate_limited: 'Too many attempts. Try again in {time}.',
        mfa_locked_out: 'Too many incorrect codes. Sign in again to get a new code.',
        resend_cooldown: 'Please wait before requesting another code.',
        code_format: 'Enter the {length}-digit code from your email.',
        timeout: 'Sign-in took too long. Please try again.',
        unexpected: 'Something went wrong. Please try again.'
      }
    }
  }
};

module.exports.auth = auth;
